<template>
    <div>
        <template v-if="busy">
            <CenteredMessage :spinner="busy">
                <template>Lädt Widget...</template>
            </CenteredMessage>
        </template>
        <template v-else>
            <template v-if="success">
                <div class="text-center my-3">
                    <font-awesome-icon
                        icon="check-circle"
                        class="mb-3 text-success"
                        style="font-size: 3.5rem"
                    />
                    <p>Anwesenheit erfolgreich eingetragen</p>
                </div>
            </template>
            <template v-else>
                <b-form-group label="Stimme" label-for="singer" :label-size="size">
                    <b-select
                        id="singer"
                        :size="size"
                        :options="singer.options"
                        v-model="filter.singer"
                    ></b-select>
                </b-form-group>
                <b-form-group label="Werk" label-for="werk" :label-size="size">
                    <b-select
                        id="werk"
                        :size="size"
                        :options="werke.options"
                        v-model="filter.werke"
                        :disabled="werke.busy"
                    ></b-select>
                </b-form-group>
                <template v-if="termin.busy">
                    <Spinner small block />
                </template>
                <template v-else>
                    <template v-if="termin.content">
                        <p class="text-center">
                            Für Termin
                            <b>
                                {{$moment(termin.content.datum).format("DD.MM.Y")}} {{termin.content.start}}
                                <em>({{termin.content.pk_bezeichnung}})</em>
                            </b> buchen
                        </p>
                    </template>
                    <template v-else>
                        <p class="text-center">Keine aktuellen Termine für dieses Konzert vorhanden</p>
                    </template>
                    <template v-if="error">
                        <p class="text-danger">{{error}}</p>
                    </template>
                    <b-button
                        :size="size"
                        :disabled="!validFilter || termin.busy"
                        block
                        @click="putAll"
                    >Alle anwesend buchen</b-button>
                </template>
            </template>
            <b-button
                :size="size"
                variant="link"
                :disabled="!validSelectFilter"
                block
                @click="linkToFullView"
            >Anwesenheitsverwaltung aufrufen</b-button>
        </template>
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Size from "@/mixins/Size/Size";
import WidgetContent from "@/mixins/Widget/WidgetContent";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";
import Spinner from "@/components/Spinner/Spinner";

const AnwesenheitsverwaltungApi = ApiFactory.get("anwesenheitsverwaltung");
const WerkeApi = ApiFactory.get("werke");

export default {
    name: "Anwesenheitsverwaltung",
    mixins: [WidgetContent, Size],
    components: {
        CenteredMessage,
        Spinner
    },
    props: ["url"],
    data() {
        return {
            filter: {
                singer: null,
                werke: null,
                termin: null
            },
            singer: {
                options: [
                    {
                        value: null,
                        text: "Stimme auswählen..."
                    },
                    {
                        value: "sopran",
                        text: "Sopran"
                    },
                    {
                        value: "alt",
                        text: "Alt"
                    },
                    {
                        value: "tenor",
                        text: "Tenor"
                    },
                    {
                        value: "bass",
                        text: "Bass"
                    }
                ]
            },
            werke: {
                busy: false,
                options: [
                    {
                        value: null,
                        text: "Werk auswählen..."
                    }
                ]
            },
            termin: {
                busy: false,
                content: null
            },
            validFilter: false,
            success: false,
            error: null
        };
    },
    computed: {
        storedFilter() {
            const pages = this.$store.getters.getPages;
            if (pages.anwesenheitsverwaltung_neu) {
                return pages.anwesenheitsverwaltung_neu.filter;
            } else {
                return this.filter;
            }
        },
        validSelectFilter() {
            return this.filter.singer !== null && this.filter.werke !== null;
        }
    },
    created() {
        this.filter = { ...this.storedFilter };
        this.fetchWerke();
    },
    watch: {
        filter: {
            handler() {
                if (this.validSelectFilter) {
                    this.fetchNearestTermin();
                }
            },
            deep: true
        }
    },
    methods: {
        async fetchNearestTermin() {
            this.termin.busy = true;
            const response = await AnwesenheitsverwaltungApi.getNearestTermin(
                this.filter.werke,
                this.filter.singer
            );
            if (response.ok) {
                if (response.json.collection) {
                    this.filter.termin = response.json.collection[0].id;
                    this.termin.content = response.json.collection[0];
                } else {
                    this.filter.termin = null;
                    this.termin.content = null;
                }
            } else {
                this.filter.termin = null;
                this.termin.content = null;
            }
            this.validFilter =
                this.validSelectFilter && this.filter.termin !== null;
            this.termin.busy = false;
        },
        async fetchWerke() {
            this.werke.busy = true;
            this.werke.options = [
                { value: null, text: "Werke werden geladen..." }
            ];
            this.filter.werke = null;

            const response = await WerkeApi.get();
            if (response.ok) {
                const data = response.json.collection;

                var options = [{ value: null, text: "Werk auswählen..." }];
                options = options.concat(
                    data.map(item => {
                        return {
                            value: item.id,
                            text:
                                item.bezeichnung +
                                " - " +
                                this.$moment(item.verfallsdatum)
                                    .subtract("1", "day")
                                    .format("DD.MM.Y")
                        };
                    })
                );
                this.werke.options = options;

                if (this.storedFilter.werke) {
                    this.filter.werke = this.storedFilter.werke;
                }
            }
            this.werke.busy = false;
        },
        selectFilter() {
            const filter = { ...this.filter };
            this.$store.dispatch("pages", {
                anwesenheitsverwaltung_neu: {
                    filter: filter
                }
            });
        },
        async putAll() {
            if (this.validFilter) {
                this.selectFilter();
                const response = await AnwesenheitsverwaltungApi.putAll(
                    this.filter.termin,
                    this.filter.singer
                );
                if (response.ok) {
                    this.success = true;
                } else {
                    this.error = "Fehler beim Buchen";
                }
            } else {
                this.error = "Bitte korrekte Stimme und Werk auswählen";
            }
        },
        linkToFullView() {
            this.selectFilter();
            this.$router.push("/anwesenheitsverwaltung_neu");
        }
    }
};
</script>